module.exports = __webpack_public_path__ + "89dcb0a8d16dff0a5a5d2da6980e3958.svg";